import { useState } from "react"
import { cn } from "@/lib/utils"

export function AgeGate() {
  const [verified] = useState(
    () => sessionStorage.getItem("age-verified") === "true"
  )
  const [exiting, setExiting] = useState(false)
  const [visible, setVisible] = useState(!verified)

  const handleConfirm = () => {
    sessionStorage.setItem("age-verified", "true")
    setExiting(true)
    setTimeout(() => setVisible(false), 400)
  }

  const handleDeny = () => {
    window.location.href = "https://www.google.com"
  }

  if (!visible) return null

  return (
    <div
      className={cn(
        "fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-md transition-opacity duration-400",
        exiting ? "opacity-0" : "opacity-100"
      )}
    >
      <div
        className={cn(
          "mx-4 w-full max-w-md rounded-3xl border border-border/50 bg-card p-8 text-center shadow-2xl transition-all duration-400",
          exiting ? "scale-95 opacity-0" : "scale-100 opacity-100"
        )}
      >
        {/* 18+ badge */}
        <div className="mx-auto mb-6 flex size-20 items-center justify-center rounded-full border-3 border-destructive bg-destructive/10">
          <span className="text-3xl font-extrabold text-destructive">18+</span>
        </div>

        <h2 className="mb-2 text-2xl font-extrabold">Potwierdzenie Wieku</h2>
        <p className="mb-8 text-muted-foreground">
          Ta strona jest przeznaczona wylacznie dla osob pelnoeletnich. Czy masz
          ukonczonych 18 lat?
        </p>

        <div className="flex gap-4">
          <button
            onClick={handleDeny}
            className="flex-1 rounded-xl border border-border px-6 py-3 text-sm font-bold transition-all hover:bg-muted"
          >
            NIE
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 rounded-xl bg-zielarz-green px-6 py-3 text-sm font-bold text-white transition-all hover:bg-zielarz-green-light hover:shadow-lg hover:shadow-zielarz-green/25"
          >
            TAK, MAM 18 LAT
          </button>
        </div>

        <p className="mt-6 text-xs text-muted-foreground">
          Wchodzac na strone akceptujesz, ze produkty tytoniowe i nikotynowe sa
          przeznaczone wylacznie dla osob doroslych.
        </p>
      </div>
    </div>
  )
}
